// import { createStore } from "vuex";
import { createStore } from "vuex";
const savedLanguage = localStorage.getItem("currentLanguage");

export default createStore({
    state: {
        currentLanguage: savedLanguage || "pl",
    },
    mutations: {
        toggleLanguage(state) {
            state.currentLanguage = state.currentLanguage === 'pl' ? 'en' : 'pl';
            localStorage.setItem("currentLanguage", state.currentLanguage);

        },
    },
    actions: {
        toggleLanguage({ commit }) {
            commit('toggleLanguage');
        },
    },
    getters: {
        getCurrentLanguage: (state) => state.currentLanguage,
    },
})